import { render, staticRenderFns } from "./BeneficiaryBlock.vue?vue&type=template&id=25f4859a&"
import script from "./BeneficiaryBlock.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports